import React from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import DashboardSidebarNavHead from '€components/DashboardSideBarHead';
import DashboardSidebarNav from '€components/DashboardSidebarNav';

const DashboardSideBar: React.FC = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Drawer
                variant="permanent"
                anchor="left"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <DashboardSidebarNavHead open={open} setOpen={setOpen} />
                <DashboardSidebarNav />
            </Drawer>
        </div>
    );
};

export default DashboardSideBar;
